import { Controller, useFormContext } from 'react-hook-form'

import { castError } from 'modules/expenses/components/expenses/Detail/_newForm/castError'
import withCustomizationFields, {
  WithCustomizationFieldsProps,
} from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import withFieldPermissions, {
  WithFieldPermissionsProps,
} from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'
import CategorySelector from 'modules/expenses/components/expenses/Form/CategorySelector'

import { shouldShowCategoryBlock } from './form/schema'

const FIELD_NAME = 'category'

const CategoryField = ({
  isFieldMandatory,
  customizationFields,
  isFieldReadOnly,
  resourceType,
}: WithCustomizationFieldsProps & WithFieldPermissionsProps) => {
  const {
    control,
    setValue,
    formState: { errors },
  } = useFormContext()

  const showBlock = shouldShowCategoryBlock(resourceType)
  if (!showBlock) return null

  return (
    <Controller
      control={control}
      name={FIELD_NAME}
      render={({ field }) => (
        <CategorySelector
          customizationFields={customizationFields}
          error={castError(errors?.category)}
          value={field.value}
          onOpenChange={() => {}}
          onSelectedCategory={(value) => {
            field.onChange(value)
            setValue('subcategory', undefined, { shouldDirty: true, shouldValidate: true })
          }}
          mandatory={isFieldMandatory}
          readonly={isFieldReadOnly}
        />
      )}
    />
  )
}

export default withCustomizationFields(withFieldPermissions(CategoryField, FIELD_NAME))
